import './addPagination.css'
import Pagination from '@mui/material/Pagination';

const AddPagination = ({data}) =>{
    const{
        currentPage,
        totalPages
    } = data

    const handlePageChange = (event, page) => {
        const currentURL = new URL(window.location.href);
        const queryParams = new URLSearchParams(currentURL.search);
       
        queryParams.set('offset', page);
        const newUrl = currentURL.origin + currentURL.pathname + '?' + queryParams.toString()
        history.replaceState(null, '', newUrl);
    };

    return(
        <>
        { totalPages > 1 && (
        <div className='pagination-component'>
            <Pagination 
                count={totalPages} 
                page={currentPage ? currentPage : 1} 
                onChange={handlePageChange}
            />
        </div>
        )}
        </>
    )
}

export default AddPagination